import { useAppParams } from "../../../../hooks/use-app-params";
import { useAppGetRevisionRequestQuery } from "../../../../hooks/query/use-app-get-revision-request-query";
import { useSavedDocumentVM } from "../../../../hooks/document/use-saved-document-vm";
import { hasValue, isNullish } from "../../../../lib/util/common-util";
import { ReviseCreatePage } from "./_components/ReviseCreatePage/ReviseCreatePage";
import { useAppSelector } from "../../../../hooks/redux-hooks";
import { selectUserInfo } from "../../../../store/auth/slice";
import { ChangeApplicationViewModel } from "../../../../lib/object/vm/change-application-view-model";
import { AnnualReportViewModel } from "../../../../lib/object/vm/annual-report-view-model";
import { TerminationReportViewModel } from "../../../../lib/object/vm/termination-report-view-model";
import { NewApplicationViewModel } from "../../../../lib/object/vm/new-application-view-model";

export const FN40S24ReviseCreate = () => {
  const loginUserInfo = useAppSelector(selectUserInfo);

  const {
    projectId: projectIdParam,
    documentId,
    revisionRequestId,
  } = useAppParams();

  const { data: revisionRequest } = useAppGetRevisionRequestQuery(
    {
      revisionRequestId: revisionRequestId ?? -1,
    },
    { skip: isNullish(revisionRequestId) },
  );

  const { projectId, vmAndCallback, validationErrors } =
    useSavedDocumentVM(documentId);

  return (
    <>
      {hasValue(loginUserInfo) &&
        hasValue(projectId) &&
        hasValue(documentId) &&
        hasValue(revisionRequestId) &&
        hasValue(vmAndCallback) &&
        hasValue(validationErrors) &&
        hasValue(revisionRequest) && (
          <>
            {vmAndCallback?.type === "new_application" && (
              <ReviseCreatePage<NewApplicationViewModel>
                loginUserInfo={loginUserInfo}
                projectIdParam={projectIdParam}
                projectId={projectId}
                documentId={documentId}
                revisionRequestId={revisionRequestId}
                vmAndCallback={vmAndCallback}
                validationErrors={validationErrors}
                initialRevisionRequest={revisionRequest}
              />
            )}
            {vmAndCallback?.type === "change_application" && (
              <ReviseCreatePage<ChangeApplicationViewModel>
                loginUserInfo={loginUserInfo}
                projectIdParam={projectIdParam}
                projectId={projectId}
                documentId={documentId}
                revisionRequestId={revisionRequestId}
                vmAndCallback={vmAndCallback}
                validationErrors={validationErrors}
                initialRevisionRequest={revisionRequest}
              />
            )}
            {vmAndCallback?.type === "annual_report" && (
              <ReviseCreatePage<AnnualReportViewModel>
                loginUserInfo={loginUserInfo}
                projectIdParam={projectIdParam}
                projectId={projectId}
                documentId={documentId}
                revisionRequestId={revisionRequestId}
                vmAndCallback={vmAndCallback}
                validationErrors={validationErrors}
                initialRevisionRequest={revisionRequest}
              />
            )}
            {vmAndCallback?.type === "termination_report" && (
              <ReviseCreatePage<TerminationReportViewModel>
                loginUserInfo={loginUserInfo}
                projectIdParam={projectIdParam}
                projectId={projectId}
                documentId={documentId}
                revisionRequestId={revisionRequestId}
                vmAndCallback={vmAndCallback}
                validationErrors={validationErrors}
                initialRevisionRequest={revisionRequest}
              />
            )}
          </>
        )}
    </>
  );
};
